export default __webpack_public_path__ + "static/section-team-2-9f97e45e1e69b98d62656dfc9965a115.jpg";